import { useMemo } from 'react';

import { CSSObject } from '@emotion/core';

const useAspectRatioStyles = (aspectRatio?: number) => {
  const styles = useMemo<CSSObject>(() => {
    if (!aspectRatio) {
      return {};
    }
    /** Credits go to css-tricks ! https://css-tricks.com/aspect-ratio-boxes/ */
    return {
      ':before': {
        content: '""',
        width: 1,
        marginLeft: -1,
        float: 'left',
        height: 0,
        paddingTop: `${(1 / aspectRatio) * 100}%`,
      },
      ':after': {
        content: '""',
        display: 'table',
        clear: 'both',
      },
    };
  }, [aspectRatio]);

  return styles;
};

export default useAspectRatioStyles;
